import oldDatesList from './old-dates-list'
import chooseManager from './choose-manager'
import notification from './notification'
import validation from './validation'

export default {
    oldDatesList,
    chooseManager,
    notification,
    validation
}
